import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { IUser } from '@bca-shared/models/user';

@Component({
  selector: 'bca-choose-user',
  templateUrl: 'choose-user.component.html',
  styleUrls: ['choose-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseUserComponent implements OnInit {
  @Input()
  users: IUser[];
  @Input()
  selectedUserId: number;

  @Output()
  selected = new EventEmitter<number>();

  ngOnInit(): void {
    const { selectedUserId, selected } = this;
    selected.emit(selectedUserId);
  }
}
